export enum refusalsPaths {
  root = '/refusals',
}
